import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Form } from "antd";
import Button from "@/common/elements/Button";
import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import useDialog from "@/hooks/useDialog";
import { useSelector } from "react-redux";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { SCHEMA_NAME } from "@/util/common_variable";

const JailIncidentInvolvedReportInformation = ({
  data,
  disciplineRequired = "",
  isFieldEnable,
  startingPoint = "",
}) => {
  const { showDialog } = useDialog();

  const onHandleViewComment = () => {
    showDialog("info", {
      content: data?.getFieldValue("hearingComments") || "No comment available",
      confirmButtonText: "Ok",
    });
  };

  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Report Information</span>
      </StyledSectionHeading>

      <FieldSecurityProvider
        entity={SCHEMA_NAME.JAIL_INCIDENTS_INVOLVED_INMATE}
        startingPoint={startingPoint}
        bookingsFieldsEnabled={isFieldEnable}
      >
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={6}>
            <SecureFormItem
              fieldName="jailIncidentsInvolvementType"
              formItemProps={{ 
                name: "jailIncidentsInvolvementType",
                label: "Involvement Type",
                rules: [
                  {
                    required: true,
                  },
                ],
              }}
            >
              <Select
                options={getOptionsFromRefList("JailIncidentsInvolvementType")}
                disabled={!isFieldEnable}
              />
            </SecureFormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <SecureFormItem
              fieldName="disciplineRequired"
              formItemProps={{ 
                name: "disciplineRequired",
                label: "Action Taken",
              }}
            >
              <Select
                options={getOptionsFromRefList("Discipline_Required")}
                disabled={!isFieldEnable}
              />
            </SecureFormItem>
          </StyledGridCol>
        </StyledGridRow>

        {!isNonEmptyVariable(disciplineRequired) && (
          <>
            <StyledGridRow gutter={16}>
              <StyledGridCol lg={7}>
                <SecureFormItem
                  fieldName="startDateTime"
                  formItemProps={{ 
                    name: "startDateTime",
                    label: "Start Date/Time",
                  }}
                >
                  <CommonDatePicker
                    format="MM/DD/YYYY HH:mm"
                    disabled={!isFieldEnable}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol lg={7}>
                <SecureFormItem
                  fieldName="hearingDueDateTime"
                  formItemProps={{ 
                    name: "hearingDueDateTime",
                    label: "Hearing Due Date/Time",
                  }}
                >
                  <CommonDatePicker
                    format="MM/DD/YYYY HH:mm"
                    disabled={!isFieldEnable}
                  />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>

            <StyledGridRow gutter={16}>
              <StyledGridCol lg={7}>
                <SecureFormItem
                  fieldName="hearingDateTime"
                  formItemProps={{ 
                    name: "hearingDateTime",
                    label: "Hearing Date/Time",
                  }}
                >
                  <CommonDatePicker
                    format="MM/DD/YYYY HH:mm"
                    disabled={!isFieldEnable}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol lg={6}>
                <SecureFormItem
                  fieldName="hearingOfficerStaffID"
                  formItemProps={{ 
                    name: "hearingOfficerStaffID",
                    label: "Hearing Officer",
                  }}
                >
                  <Select
                    options={getOptionsFromRefList("", true, true, true)}
                    disabled={!isFieldEnable}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol lg={6}>
                <SecureFormItem
                  fieldName="reviewOfficerStaffID"
                  formItemProps={{ 
                    name: "reviewOfficerStaffID",
                    label: "Review Officer",
                  }}
                >
                  <Select
                    options={getOptionsFromRefList("", true, true, true)}
                    disabled={!isFieldEnable}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol lg={5}>
                <SecureFormItem
                  fieldName="jailIncidentsResults"
                  formItemProps={{ 
                    name: "jailIncidentsResults",
                    label: "Results",
                  }}
                >
                  <Select
                    options={getOptionsFromRefList("JailIncidentsResults")}
                    disabled={!isFieldEnable}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol xs={24} lg={24}>
                <SecureFormItem
                  fieldName="hearingComments"
                  formItemProps={{ 
                    name: "hearingComments",
                    label: "Comments",
                  }}
                >
                  <TextField
                    inputType="textarea"
                    rows="3"
                    disabled={!isFieldEnable}
                  />
                </SecureFormItem>
                <Button
                  type="primary"
                  color="primary"
                  onClick={onHandleViewComment}
                >
                  View Comments
                </Button>
              </StyledGridCol>
            </StyledGridRow>
          </>
        )}
      </FieldSecurityProvider>
    </>
  );
};

export default JailIncidentInvolvedReportInformation;
